@if(isDisabled){
<app-loader></app-loader>
}
<div class="row">
    <div class="col"></div>
    <div class="col-auto">
        <button class="btn btn-primary btn-sm" [routerLink]="['/master/userdetail/usermaster/add/',0]">+ Add New
            User</button>
    </div>
</div>
<div class="card mt-2">
    <div class="card-header">
        User Master
    </div>
    <div class="card-body">
        <div class="mt-3">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th style="width: 5px;">#</th>
                        <th style="width: 5px;">Action</th>
                        <th>Name</th>
                        <th>Username</th>
                        <th>UserType</th>
                        <th>Phone</th>
                        <th>Active</th>
                        <th>IsSuperAdmin</th>
                    </tr>
                </thead>
                <tbody>
                    <tr style="font-size: 11px;" *ngFor="let e of TableData ;let i = index">
                        <td>
                            <span style="width: max-content;" class="d-block">{{i+1}}</span>
                        </td>
                        <td style="text-align: center;">
                            <span style="width: max-content;" class="d-block">
                                <i [routerLink]="['/master/userdetail/usermaster/add/',e['UserMasterId']]"
                                    class="bi bi-pencil-square text-warning cursor-pointer"></i>
                            </span>
                        </td>
                        <td>
                            <span style="width: max-content;" class="d-block">
                                {{e['FirstName']}} {{e['MiddleName']}} {{e['LastName']}}
                            </span>
                        </td>
                        <td>
                            <span style="width: max-content;" class="d-block">
                                {{e['UserName']}}
                            </span>
                        </td>
                        <td>
                            <span style="width: max-content;" class="d-block">
                                {{e['UserType']}}
                            </span>
                        </td>
                        <td>
                            <span style="width: max-content;" class="d-block">
                                {{e['Phone']}}
                            </span>
                        </td>
                        <td class="text-center align-middle">
                            @if(e['Active']){
                            <span class="badge text-bg-success">Yes</span>
                            }@else{
                            <span class="badge text-bg-danger">No</span>
                            }
                        </td>
                        <td class="text-center align-middle">
                            @if(e['IsSuperAdmin']){
                            <span class="badge text-bg-success">Yes</span>
                            }@else{
                            <span class="badge text-bg-danger">No</span>
                            }
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button (click)="ExcelDump()" class="btn btn-primary btn-sm">
                    <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Excel':'Loading...'}}</button>
            </div>
        </div>
    </div>
</div>